import { useTranslation } from 'react-i18next'
import Layout from 'containers/Layout'
import useModal from 'hooks/useModal'
import { useEffect, useState } from 'react'
import apiGet from 'lib/network/apiGet'
import AddEditRole from './AddEditRole'
import Role from './Role'
import Button from 'components/atoms/Button'
import { useSelector } from 'react-redux'
import { get } from 'lodash'
import LanguageSwitcher from 'components/atoms/LanguageSwitcher'

const Roles = () => {
  const { t } = useTranslation()
  const [role, setRole] = useState(null)
  const [roleId, setRoleId] = useState(null)
  const userFromStore = useSelector(state => get(state, 'user.user'))

  // eslint-disable-next-line
  const hasAdminAccess = userFromStore?.roles?.some(role => role.type === 'admin')

  const fetchRole = async () => {
    const response = await apiGet('roles')
    setRole(response?.data)
  }

  const [menuItems, setMenuItems] = useState([])

  useEffect(() => {
    if (hasAdminAccess) {
      fetchMenuItems()
    }
  }, [hasAdminAccess])

  const fetchMenuItems = async () => {
    const response = await apiGet('menu-items')
    setMenuItems(response?.data)
  }

  useEffect(() => {
    if (hasAdminAccess) {
      fetchRole()
    }
  }, [hasAdminAccess])

  const [RoleModal, openRoleModal] = useModal({
    content: <AddEditRole menuItems={menuItems} id={roleId} fetchData={fetchRole} setId={setRoleId} />,
    title: roleId ? t('roles.modal.editRole') : t('roles.modal.addNewRole'),
    // dimensions: {
    //   height: 'auto',
    //   maxHeight: 'auto',
    // },
    dimensions: {
      height: 'auto',
      width: '90vw',
      maxWidth: '500px',
      minHeight: 'auto',
      minWidth: '280px',
    },
  })

  const openModal = () => {
    setRoleId(null)
    openRoleModal()
  }

  return (
    <Layout
      headerRight={
        <div className="mt-4 flex sm:mt-0 sm:space-x-4 rtl:space-x-reverse gap-3">
          <Button onClick={openModal}>{t('roles.buttons.addRole')}</Button>
        </div>
      }
      title={t('roles.title')}
    >
      {role && <Role setId={setRoleId} data={role} openModal={openRoleModal} fetch={fetchRole} />}
      <RoleModal height={600} />
    </Layout>
  )
}

export default Roles
